import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { GenericPayloadType } from '@ezugi/types';

import { TableLimit } from './table';

type LobbyPatchPayload = GenericPayloadType;

export type AuthGroup = {
  id: number;
  locale: string;
  tables: number[];
}

export type LobbyTable = {
  id: string;
  tableId: number;
  title: string;
  gameId: number;
  limits: Record<string, any>;
  active: boolean;
  image: string | null;
  open_table_image: string;
  fallbackImage: string | null;
  language: string;
  playersCount: number;
  freeSeatsCount: number | undefined;
  seats: unknown[] | undefined;
  isOccupied: boolean;
  history: unknown[];
}

type AuthTable = {
  title: string;
  active: boolean;
  open_table_image: string | null;
  closed_table_image: string | null;
  dealer_id: string;
  dealer_image: string | null;
  dealer_name: string;
  dynamic_table_image: string | null;
  use_dynamic_image: boolean;
  game_id: number;
  has_hybrid: boolean;
  history: unknown[];
  hybrid_table_id: number;
  id: number;
  languages: string[];
  limits: Record<string, TableLimit>;
  meta_table_id: number;
  new: boolean;
  open_hours: {
    close: string | null;
    open: string | null;
  }
  players_count: number;
  round_start_time: {
    time_left: number;
    timestamp: number;
  }
}

export type LobbyState = {
  open: boolean;
  openMenuWidget: boolean;
  loading: boolean;
  tables: Record<string, LobbyTable>;
  authGroups: Record<string, AuthGroup>;
  authTables: Record<string, AuthTable>;
  type: string;
}

type ToggleFavoritePayloadType = {
  id: number;
  favorite: boolean;
};

const initialState: LobbyState = {
  open: false,
  openMenuWidget: false,
  loading: false,
  type: 'default',
  tables: {},
  authGroups: {},
  authTables: {},
};

const lobbySlice = createSlice({
  name: 'lobby',
  initialState,
  reducers: {
    open(state) {
      return {
        ...state,
        open: true,
      };
    },
    openMenuWidget(state) {
      return {
        ...state,
        open: false,
        openMenuWidget: true,
      };
    },
    close(state) {
      return {
        ...state,
        loading: false,
        open: false,
        openMenuWidget: false,
      };
    },
    patch(state, { payload }: PayloadAction<LobbyPatchPayload>) {
      return {
        ...state,
        ...payload,
      };
    },
    toggle() {},
    navigate(_state, { payload: _ }: PayloadAction<GenericPayloadType>) {},
    redirect() {},
    send() {},
    post() {},
    categoryClick(_state, { payload: _ }) {},
    toggleFavorite(_state, { payload: _ }: PayloadAction<ToggleFavoritePayloadType>) {},
  },
});

export const lobbyActions = lobbySlice.actions;
export default lobbySlice.reducer;
